import { render, staticRenderFns } from "./DBFScorecardSection.vue?vue&type=template&id=431436a7&scoped=true"
import script from "./DBFScorecardSection.vue?vue&type=script&lang=js"
export * from "./DBFScorecardSection.vue?vue&type=script&lang=js"
import style0 from "./DBFScorecardSection.vue?vue&type=style&index=0&id=431436a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431436a7",
  null
  
)

export default component.exports